import { Box } from '@stereograph/teia-system-design/components/Box';
import { Title } from '@stereograph/teia-system-design/components/Typography';
import { AliasTableView } from './AliasTableEditorView';

export const AliasTableTabView = () => {
  return (
    <Box sx={{
      height: 1,
      width: 1,
      display: 'flex',
      flexDirection: 'column',
      p: 1,
      gap: 1,
    }}
    >
      <Title sx={{
        alignSelf: 'center',
        m: 1,
        mb: 5,
      }}
      >
        Alias Table
      </Title>
      <AliasTableView />
    </Box>
  );
};
